// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__38chy","title":"styles_title__1vFyN","small":"styles_small__po0M7","box":"styles_box__k8SO8"};